import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AddObjectComponent } from "../add-object/add-object.component";
import * as object_settings from "../courses/courses-data/object_settings.json";
import { AddExamComponent } from "../add-exam/add-exam.component";
import { AppService } from "src/app/services/app/app.service";
@Component({
  selector: "app-select-object",
  templateUrl: "./select-object.component.html",
  styleUrls: ["./select-object.component.scss"],
})
export class SelectObjectComponent {
  public objectArr: any[] = [
    { name: "Text", img: "assets/images/object_icons/text.svg", type: "text" },
    {
      name: "YouTube",
      img: "assets/images/object_icons/youtube.svg",
      type: "youtube",
    },
    { name: "Link", img: "assets/images/object_icons/link.svg", type: "link" },
    { name: "PDF", img: "assets/images/object_icons/pdf.svg", type: "pdf" },
    // {
    //   name: "Survey",
    //   img: "assets/images/object_icons/survey.png",
    //   type: "survey",
    // },
    {
      name: "Audio",
      img: "assets/images/object_icons/audio.svg",
      type: "audio",
    },
    {
      name: "image",
      img: "assets/images/object_icons/image.svg",
      type: "image",
    },
    { name: "File", img: "assets/images/object_icons/file.svg", type: "file" },
    {
      name: "Video",
      img: "assets/images/object_icons/video.svg",
      type: "video",
    },
    // {
    //   name: "Iframe",
    //   img: "assets/images/object_icons/iframe.svg",
    //   type: "iframe",
    // },
    { name: "Exam", img: "assets/images/object_icons/quiz.svg", type: "exam" },
  
    // {
    //   name: "Forms",
    //   img: "assets/images/object_icons/forms.png",
    //   type: "forms",
    // },
    // {
    //   name: "Knowledge Base",
    //   img: "assets/images/object_icons/knowledge_base.png",
    //   type: "knowledge_base",
    // },
  ];
  public contentDetails: any[] = (object_settings as any).default;
  public isNoExamAllowed:boolean=false;
  constructor(
    public dialogRef: MatDialogRef<SelectObjectComponent>,
    public dialog: MatDialog,
    private appService:AppService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {}
  ngOnInit(): void {
    // if(this.dialogData){
    //   this.dialogData.isExamAdded
    // }
    // if any section exam is added once then don't allow to add for second time
    if(this.dialogData.isExamAllowed==true){
      if(this.dialogData.isExamDisabled){
        this.isNoExamAllowed=true;
      }
      else{
        this.isNoExamAllowed=false;
      }
    }
    else{
      let findExamObj=this.objectArr.findIndex(item=>item.name=='exam')
      this.objectArr.splice(findExamObj,1)
    }
    if(this.dialogData.isExamAdded){
     let findExamObj=this.objectArr.findIndex(item=>item.name=='exam')
     if(findExamObj){
      this.isNoExamAllowed=true
     }
    }
   
  }
  onCancel() {
    this.dialogRef.close();
  }
  onAddObject(value: string) {
    let selectedItem: any = JSON.parse(
      JSON.stringify(this.contentDetails.filter((item) => item.type == value))
    );
    if(value=='exam' && this.isNoExamAllowed){
      this.appService.showToastMessage('warning',
      'You cannot create exam without giving learning material to user. so please first create any other type of sub-section for user to learn',5000)
      return     
    }
    this.dialogRef.close();
  if(value!='exam'){
        let settingsArr: any[] = selectedItem[0]["sett"]
        settingsArr.map((item: any) => (item["key_value"] = ""));
    // }
      const dialogRef = this.dialog.open(AddObjectComponent, {
        width: this.getDialogWidth(),
        height: "90%",
        maxWidth: "100vw",
        minWidth:'280px',
        enterAnimationDuration: "300ms",
        exitAnimationDuration: "300ms",
        data: { type: value, selectedObject: selectedItem },
      });
      dialogRef.afterClosed().subscribe((result) => {
      });
    }
   else{
    this.onManageExam('')
   } 
  }
  onManageExam(id: any) {
    const dialogRef = this.dialog.open(AddExamComponent, {
      width: '96%',
      height: '93%',
      maxWidth: '100vw',
      maxHeight: "800px",
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: { course_id: id,exam_type:"s_e" }
    });
    dialogRef.afterClosed().subscribe(result => {
   
    });
  }
  getDialogWidth(): string {
    // Adjust the breakpoints and corresponding heights based on your requirements
    if (window.innerWidth > 1400) {
      return '60%'; // Set the height for small screens
    } else if (window.innerWidth >1140 && window.innerWidth < 1400) {
      return '80%'; // Set the height for medium screens
     } else if (window.innerWidth >768 && window.innerWidth < 1140) {
        return '85%'; // Set the height for medium screens
       
    } else {
      return '90%'; // Set the height for large screens
    }
  }
 
}
